export function calculateAgeAtGivenTime(
  birthdate: Date,
  givenTime: Date | undefined
): {
  years: number;
  months: number;
  days: number;
} {
  if (!givenTime) {
    throw new Error('No given time to calculate age');
  }
  if (birthdate > givenTime) {
    throw new Error('Invalid birthdate (in the future)');
  }

  let years = givenTime.getFullYear() - birthdate.getFullYear();
  let months = givenTime.getMonth() - birthdate.getMonth();
  let days = givenTime.getDate() - birthdate.getDate();

  if (days < 0) {
    months--;
    const lastMonth = new Date(
      givenTime.getFullYear(),
      givenTime.getMonth(),
      0
    );
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months, days };
}
